import { useState, useEffect, useRef } from "react";

export function usePersistedState(key, initial) {
  const [value, setValue] = useState(() => {
    const saved = sessionStorage.getItem(`state:${key}`);
    return saved !== null ? JSON.parse(saved) : initial;
  });
  useEffect(() => { sessionStorage.setItem(`state:${key}`, JSON.stringify(value)); }, [key, value]);
  return [value, setValue];
}

// Saves scroll position for a page and restores it once its data is loaded
export function useScrollRestore(key, ready) {
  const readyRef = useRef(false);
  useEffect(() => {
    const save = () => { if (readyRef.current) sessionStorage.setItem(`scroll:${key}`, String(window.scrollY)); };
    window.addEventListener("scroll", save, { passive: true });
    return () => window.removeEventListener("scroll", save);
  }, [key]);
  useEffect(() => {
    if (!ready || readyRef.current) return;
    const y = Number(sessionStorage.getItem(`scroll:${key}`) || 0);
    requestAnimationFrame(() => {
      if (y > 0) window.scrollTo(0, y);
      readyRef.current = true;
    });
  }, [key, ready]);
}
